import path from 'path';

import { INFORMATION_ROUTE } from './pages/Information';

export const CREATE_ROUTE = {
  name: 'Create',
  path: path.join('new', INFORMATION_ROUTE.path),
};
